export const roundTo2 = value => parseFloat((value || 0).toFixed(2));

